/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.si_theme = {
    attach: function (context, settings) {

    }
  };

})(jQuery, Drupal);
